var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73.5759,
    height: 73.5759,
    fill: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2627 61.3133C10.5766 61.3133 9.13314 60.713 7.93243 59.5122C6.73171 58.3115 6.13135 56.8681 6.13135 55.182V18.394C6.13135 16.7079 6.73171 15.2645 7.93243 14.0638C9.13314 12.8631 10.5766 12.2627 12.2627 12.2627H61.3133C62.9994 12.2627 64.4428 12.8631 65.6435 14.0638C66.8443 15.2645 67.4446 16.7079 67.4446 18.394V55.182C67.4446 56.8681 66.8443 58.3115 65.6435 59.5122C64.4428 60.713 62.9994 61.3133 61.3133 61.3133H12.2627ZM36.788 39.8537L61.3133 24.5253V18.394L36.788 33.7223L12.2627 18.394V24.5253L36.788 39.8537Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDark);
export default __webpack_public_path__ + "static/media/mail_dark.79cad941bbbc4409da10eedf83e16040.svg";
export { ForwardRef as ReactComponent };